@if (form && form?.get('assistTypesConfigId')?.value !== null) {
    <div class="w-full" (keydown)="onKeyDown($event)">
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
            <h2>Stillingar - Tölvuaðstoð og breytingabeiðnir</h2>
            <p>Hér getur þú átt við stillingar fyrir tölvuaðstoð og breytingabeiðnir</p>
        </div>
        <form [formGroup]="form" #profileInNgForm="ngForm" (keyup.enter)="save()">
            <div class="col-span-4 mb-2 mt-1">
                <mat-form-field class="w-full mb-4">
                    <mat-label>Tegund</mat-label>
                    <mat-select
                        (selectionChange)="onChangeAssistType($event.value)"
                        [formControlName]="'assistTypesConfigId'"
                        placeholder="Tegund"
                    >
                        @for (type of assistTypes; track type) {
                            <mat-option [value]="type.value">
                                {{ type.viewValue }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="w-full mb-4">
                    <mat-label>Netfang ábyrgðaraðila</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'mat_solid:email'" matPrefix></mat-icon>
                    <input id="email" [formControlName]="'assignedToEmail'" matInput />
                    @if (form.get('assignedToEmail').hasError('required')) {
                        <mat-error> Vinsamlegast sláðu inn netfang </mat-error>
                    }
                    @if (form.get('assignedToEmail').hasError('validEmail') && !form.get('assignedToEmail').hasError('required')) {
                        <mat-error> Vinsamlegast sláðu inn gilt netfang </mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-full mb-4">
                    <mat-label>Merkingar (e. tags)</mat-label>
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:tag'" matPrefix></mat-icon>
                    <input id="tags" [formControlName]="'tags'" matInput />
                    <mat-hint
                        >Allar beiðnir af tegundinni „<strong>{{ selectedAssistType?.name }}</strong
                        >“ fá þessa merkingu. Ef um fleiri en eina merkingu er um að ræða skal notast við semíkommu (;) til
                        aðgreiningar</mat-hint
                    >
                </mat-form-field>
            </div>
            <mat-accordion class="mt-2">
                <ng-container>
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>Tilgreina takmarkaða opnun</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="grid grid-cols-4 gap-6 w-full mt-1">
                            <div class="col-span-4 sm:col-span-2 ml-2">
                                <div class="flex items-center justify-between">
                                    <mat-slide-toggle
                                        class="mr-4 ml-2"
                                        [color]="'primary'"
                                        [formControlName]="'dayOpenActive'"
                                        (change)="dayOpenActiveTrigger($event)"
                                    >
                                    </mat-slide-toggle>
                                    <div class="flex-auto">
                                        <div class="leading-6 font-medium">Takmörkuð opnun</div>
                                        <div class="text-md text-secondary">Virkja takmarkaða opnun á virkum dögum</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-4 sm:col-span-1">
                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                    <mat-label>Opið frá (hh:mm)</mat-label>
                                    <input placeholder="00:00" [formControlName]="'dayOpenFrom'" matInput />
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 sm:col-span-1">
                                <mat-form-field class="fuse-mat-no-subscript w-full">
                                    <mat-label>Opið til (hh:mm)</mat-label>
                                    <input placeholder="00:00" [formControlName]="'dayOpenTo'" matInput />
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 mb-2">
                                <div class="text-[14px] font-medium mb-1">Skilaboð til notenda vegna takmörkunar</div>
                                <ckeditor
                                    [disabled]="form?.get('dayOpenTextHTML')?.disabled"
                                    [editor]="editorDayOpen"
                                    [(ngmodel)]="dayOpenTextHTML"
                                    name="dayOpenTextHTML"
                                    [ngModelOptions]="{ standalone: true }"
                                    [config]="{
                                        alignment: {
                                            options: ['left', 'right', 'center', 'justify'],
                                        },
                                        toolbar: [
                                            'heading',
                                            '|',
                                            'bold',
                                            'italic',
                                            'bulletedList',
                                            'numberedList',
                                            'link',
                                            '|',
                                            'undo',
                                            'redo',
                                        ],
                                    }"
                                    (change)="onChangeDayOpenText($event)"
                                    id="editorDayOpen"
                                ></ckeditor>
                                <mat-hint class="float-right">
                                    Skilaboðin eru birt notendum við skráningu beiðna af tegundinni
                                    <strong>{{ selectedAssistType?.name }}</strong>
                                </mat-hint>
                            </div>
                        </div>
                    </mat-expansion-panel>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>Tilgreina lokun yfir ákveðið tímabil</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="grid grid-cols-4 gap-6 w-full mt-1">
                            <div class="col-span-4 sm:col-span-2 ml-2">
                                <div class="flex items-center justify-between">
                                    <mat-slide-toggle
                                        class="mr-4 ml-2"
                                        [color]="'primary'"
                                        [formControlName]="'closedActive'"
                                        (change)="closedActiveTrigger($event)"
                                    >
                                    </mat-slide-toggle>
                                    <div class="flex-auto">
                                        <div class="leading-6 font-medium">Lokað</div>
                                        <div class="text-md text-secondary">Loka yfir valið tímabil</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-span-4 sm:col-span-2">
                                <mat-form-field class="float-left w-100">
                                    <mat-label>Lokað frá</mat-label>
                                    <input
                                        matInput
                                        (click)="pickerFrom.open()"
                                        (change)="closedFromChange($event)"
                                        [ngxMatDatetimePicker]="pickerFrom"
                                        [formControlName]="'closedFrom'"
                                    />
                                    <ngx-mat-datetime-picker #pickerFrom> </ngx-mat-datetime-picker>
                                </mat-form-field>
                                <br />
                                <mat-form-field class="float-left w-100">
                                    <mat-label>Lokað til</mat-label>
                                    <input
                                        matInput
                                        (click)="pickerTo.open()"
                                        [ngxMatDatetimePicker]="pickerTo"
                                        [formControlName]="'closedTo'"
                                    />
                                    <ngx-mat-datetime-picker #pickerTo> </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>
                            <div class="col-span-4 mb-2">
                                <div class="text-[14px] font-medium mb-1">Skilaboð til notenda vegna lokunar</div>
                                <ckeditor
                                    [disabled]="form?.get('closedTextHTML')?.disabled"
                                    [editor]="editorClosed"
                                    [(ngModel)]="closedTextHTML"
                                    name="closedTextHTML"
                                    [ngModelOptions]="{ standalone: true }"
                                    [config]="{
                                        alignment: {
                                            options: ['left', 'right', 'center', 'justify'],
                                        },
                                        toolbar: [
                                            'heading',
                                            '|',
                                            'bold',
                                            'italic',
                                            'bulletedList',
                                            'numberedList',
                                            'link',
                                            '|',
                                            'undo',
                                            'redo',
                                        ],
                                    }"
                                    (change)="onChangeClosedText($event)"
                                    id="closedEditor"
                                ></ckeditor>
                                <mat-hint class="float-right">
                                    Skilaboðin eru birt notendum við skráningu beiðna af tegundinni
                                    <strong>{{ selectedAssistType?.name }}</strong>
                                </mat-hint>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </ng-container>
            </mat-accordion>
            <span class="separator-line mt-4 mb-4 float-left w-100"></span>
            <span class="float-left w-100">
                <div class="flex items-center justify-end">
                    @if (form.dirty) {
                        <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                            {{ 'label_cancel' | translate }}
                        </button>
                    }
                    <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                        @if (formEnabled) {
                            <span> Vista </span>
                        }
                        @if (!formEnabled) {
                            <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                        }
                    </button>
                </div>
            </span>
        </form>
    </div>
}
